/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, Fragment, useEffect } from "react";
import { Input, Select, Form } from "antd";
//import ValidationMessage from "components/ValidationMessage/ValidationMessage";
import { InfoCircleOutlined } from "@ant-design/icons";
// import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
// import { Popover, Button } from "antd";
import {
  errorToast,
  getErrorObject,
  successToast,
  // successToast,
  verifyObject,
} from "utilities/utils";
import { ValidateSignupInput } from "./ValidateSignupForm";
import { signupIndividualClinician } from "services/SignUp";
// import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import { appRoutesConst } from "app/navigation";
import LoginHeader from "components/Login/LoginHeader";
import LoginFooter from "components/Login/LoginFooter";
import SignupCSS from "./Signup.module.scss";
import { Link } from "react-router-dom";
import FloatLabel from "components/common/FloatLabel";
import imgEyeClosed from "../../assets/images/login/eye_hide.svg";
import imgEyeOpen from "../../assets/images/login/eye_view.svg";
import selectdropdownarrow from "../../assets/images/common/selectdropdownarrow.svg";
import removeIcon from "../../assets/images/common/removeIcon.svg";
// import { createCharges } from "services/plans";
import ActionCable from "actioncable";

import {
  apiBaseUrlsWithoutApiNameSpace,
  baseWebSocketURL,
  // deletee,
} from "services/index";
import Loader from "components/common/PageLoader";
import { types } from "reducers/session";
import { appRoutesConst } from "app/navigation";
import { useNavigate } from "react-router-dom";
// import { types } from "reducers/sessionManagement";

const { Option } = Select;

// const password_info = (
//   <div className="forgot_wrapper">
//     <p className="m-0 font-13 weight-400">
//       Password should be atleast 8 characters including a number,an
//       uppercase,one special character and lowercase letter
//     </p>
//   </div>
// );

// const mobilenumber = (
//   <div className="forgot_wrapper">
//     <p className="m-0 font-13 weight-400">Mobile no should be of 10 digit</p>
//   </div>
// );

export default function SignupContainer() {
  const [state, setState] = useState({
    first_name: "",
    last_name: "",
    password: "",
    confirm_password: "",
    email: "",
    phone: null,
    country_code: "+44",
    role: "",
    backdropLoading: false,
    popup: null,
  });
  const [stripCable, setStripeCable] = useState(null);
  // action cable
  const cable = ActionCable.createConsumer(`${baseWebSocketURL}/cable`);
  const params = new URLSearchParams(window.location.search); // id=123
  let plan_id = params.get("plan_id");
  let secretKey = params.get("secretKey");

  // console.log("secretKey", secretKey);

  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  const { plan_details } = useSelector((state) => state.localStore);

  useEffect(() => {
    // console.log("state", state.popup);
    // if (state.popup === null) {
    //   setState({ ...state, backdropLoading: false });
    // }
    return () => {
      if (stripCable && typeof stripCable.unsubscribe ==='function') {
        stripCable.unsubscribe();
      }
    };
  }, []);

  const popupWindow = (url, windowName, win, w, h) => {
    const y = win.top.outerHeight / 2 + win.top.screenY - h / 2;
    const x = win.top.outerWidth / 2 + win.top.screenX - w / 2;
    return win.open(
      url,
      windowName,
      "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
        w +
        ", height=" +
        h +
        ", top=" +
        y +
        ", left=" +
        x
    );
  };

  const connectStripeChannel = (createChargesPayload) => {
    let popup = null;
    console.log("createChargesPayload", createChargesPayload);
    let stripeCable = cable.subscriptions.create(
      {
        channel: "StripeChannel",
        usr: createChargesPayload.usr,
      },
      {
        connected: function () {
          console.log("Stripe Channle Connected");
          let currentEnv = process.env.REACT_APP_ENV;
          let baseUrl = apiBaseUrlsWithoutApiNameSpace[currentEnv];
          let paymentLink = `${createChargesPayload.url}?usr=${
            createChargesPayload.usr
          }&cop=null&lp=${createChargesPayload.lp}&ep=${
            createChargesPayload.ep
          }&is_clinician=${true}&pln=${createChargesPayload.pln}`;
          popup = popupWindow(
            paymentLink,
            "Advantage Minds Checkout",
            window,
            500,
            500
          );
          // popup.addEventListener("", function () {
          //   alert("popuo closed");
          //   setState({ ...state, loading: false, backdropLoading: false });
          // });

          setState({
            ...state,
            loading: false,
            backdropLoading: true,
            popup: popup,
            isConnected: true,
          });
        },
        received: (response) => {
          console.log("Stripe Channle Recevied", response.data);
          let user = verifyObject(response, "data.direct_clinician", null);
          let token = verifyObject(
            response,
            "data.direct_clinician.auth_token",
            null
          );
          console.log("popwindow", popup);
          if (popup && !popup.closed) popup.close();
          setState({ ...state, loading: false, backdropLoading: false });
          console.log("Token", token);
          console.log("user", user);

          dispatch({
            type: types.LOGIN_SUCCESS,
            payload: { token, user },
          });
          dispatch({
            type: "IS_SIGNIN",
            payload: false,
          });
          successToast({
            content: verifyObject(response, "message", "Success"),
          });
          stripeCable.unsubscribe();

          navigateTo(appRoutesConst.appointments);
        },
        disconnected: () => {
          console.log("Stripe Channle Disconnected");
        },
      }
    );
    console.log("is closed", popup);
    console.log("is closed state", state.popup);

    setStripeCable(stripeCable);
  };

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
      errors: {
        [e.target.name]: null,
      },
    });
  };

  const handleSelectChange = (value) => {
    setState({
      ...state,
      [`role`]: value,
      errors: {
        [`role`]: null,
      },
    });
  };

  const _handleSubmit = async (e) => {
    e.preventDefault();
    let data = {
      first_name: state.first_name,
      last_name: state.last_name,
      password: state.password,
      confirm_password: state.confirm_password,
      email: state.email,
      phone: state.phone ? state.phone : "",
      registration_number: state.registration_number
        ? state.registration_number
        : "",
    };
    const errors = ValidateSignupInput(data);

    if (!errors.isValid) {
      setState({ ...state, errors: errors.errors, submitting: false });
    } else {
      let params = {};
      if (plan_id) {
        params = {
          vantage_subscription_plan_id: plan_id,
        };
      }

      if (secretKey) {
        params = {
          secret_code: secretKey,
        };
      }
      const payload = {
        direct_clinician: {
          first_name: state.first_name,
          last_name: state.last_name,
          email: state.email,
          phone_number: `${state.country_code}${state.phone}`,
          password: state.password,
          registration_number: state.registration_number,
        },
        ...params,
        role: state.role,
        device_detail: {
          device_type: "web",
          player_id: 123,
        },
      };
      try {
        // let phone = JSON.parse(localStorage.getItem("otp-phone"));
        await setState({ ...state, loading: true });
        let response = await signupIndividualClinician(payload);
        console.log("USER", response);
        let token = verifyObject(
          response,
          "data.data.direct_clinician.auth_token",
          null
        );
        if (token) {
          let user = verifyObject(response, "data.data.direct_clinician", null);
          dispatch({
            type: types.LOGIN_SUCCESS,
            payload: { token, user },
          });
          dispatch({
            type: "IS_SIGNIN",
            payload: false,
          });
          successToast({
            content: verifyObject(response, "data.message", "Success"),
          });

          navigateTo(appRoutesConst.appointments);
        } else {
          let user = verifyObject(response, "data.data", null);
          let stripe_subscription_plan_prices = verifyObject(
            plan_details,
            "stripe_subscription_plan_prices",
            null
          );

          console.log("Signup Response", user);
          let lp_price_id = null;
          let ep_price_id = null;
          if (
            stripe_subscription_plan_prices &&
            stripe_subscription_plan_prices.length > 0
          ) {
            let found = stripe_subscription_plan_prices.find(
              (d) => d.price_type === "plan_price"
            );
            let found1 = stripe_subscription_plan_prices.find(
              (d) => d.price_type === "exceeded_fair_usage_price"
            );

            if (found) {
              lp_price_id = found.stripe_price_id;
            }
            if (found1) {
              ep_price_id = found1.stripe_price_id;
            }
          }

          let createChargesPayload = {
            usr: user.id,
            cop: null,
            lp: lp_price_id,
            ep: ep_price_id,
            is_clinician: true,
            pln: plan_id,
            url: user.url,
          };
          connectStripeChannel(createChargesPayload);
        }
        // if (popup && !popup.closed) {
        //   alert("")
        //   popup.close();
        // }

        // if (response.data.message) {
        // }
      } catch (error) {
        const { message } = getErrorObject(error);
        errorToast({ content: message });
        setState({ ...state, loading: false });
      }
    }
  };

  const [passwordVisible, setPasswordVisibe] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordVisibe(!passwordVisible);
  };

  return (
    <Fragment>
      <div className={SignupCSS.signup_wrapper}>
        {state.backdropLoading && (
          <div className={SignupCSS.overlay_layout}>
            <Loader />
          </div>
        )}
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <LoginHeader />

              <div className={SignupCSS.signup_form_card}>
                <h2 className="font-24 weight-600 margin-bottom-30 text-center">
                  Sign Up to ADDVantage Minds
                </h2>

                <form onSubmit={_handleSubmit} className="login_form_wrapper">
                  <Form.Item className="margin-bottom-15">
                    <div className="form-row">
                      <div className="col-md-6">
                        <FloatLabel
                          label="First Name"
                          value={state.first_name}
                          name="first_name"
                        >
                          <Input
                            className={`form-control ${
                              state.errors &&
                              state.errors.first_name &&
                              "danger-border"
                            }`}
                            name="first_name"
                            value={state.first_name}
                            onChange={handleChange}
                            //placeholder="Enter first name"
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.first_name}
                          </span>
                        )}
                      </div>
                      <div className="col-md-6">
                        <FloatLabel
                          label="Last Name"
                          value={state.last_name}
                          name="last_name"
                        >
                          <Input
                            className={`form-control ${
                              state.errors &&
                              state.errors.last_name &&
                              "danger-border"
                            }`}
                            name="last_name"
                            value={state.last_name}
                            onChange={handleChange}
                            //placeholder="Enter last name"
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.last_name}
                          </span>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item className="margin-bottom-15">
                    <div className="form-row">
                      <div className="col-md-6">
                        <FloatLabel
                          label="Email Address"
                          value={state.email}
                          name="email"
                        >
                          <Input
                            className={`form-control height-36 input-bg-f9f9f9 weight-400 margin-0 ${
                              state.errors &&
                              state.errors.email &&
                              "danger-border"
                            }`}
                            name="email"
                            value={state.email}
                            onChange={handleChange}
                            //placeholder="Enter email address"
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.email}
                          </span>
                        )}
                      </div>{" "}
                      <div className="col-md-6">
                        <FloatLabel
                          label="Select your role"
                          name="role"
                          id="signup_role"
                          value={state.role}
                        >
                          <Select
                            showSearch
                            id="signup_role"
                            allowClear
                            className={`select-form-control ${
                              state.errors &&
                              state.errors.role &&
                              "danger-border"
                            }`}
                            dropdownClassName="select-form-control-menu"
                            suffixIcon={
                              <img
                                src={selectdropdownarrow}
                                alt="Date"
                                title="Date"
                              />
                            }
                            clearIcon={
                              <img
                                src={removeIcon}
                                alt="Remove"
                                title="Remove"
                              />
                            }
                            name="role"
                            value={state.role}
                            onChange={handleSelectChange}
                            //placeholder="Select Role"
                          >
                            {/* <Select.Option value="" disabled selected>
                              Select your role
                            </Select.Option> */}
                            <Select.Option value={"therapist"}>
                              Therapist
                            </Select.Option>
                            <Select.Option value={"councellor"}>
                              Councellor
                            </Select.Option>
                            <Select.Option value={"doctor"}>
                              Doctor
                            </Select.Option>
                          </Select>
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.role}
                          </span>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item className="margin-bottom-15">
                    <div className="form-row">
                      <div className="col-md-6">
                        <FloatLabel
                          label="Password"
                          value={state.password}
                          name="password"
                        >
                          <img
                            src={passwordVisible ? imgEyeOpen : imgEyeClosed}
                            alt="Password Eye"
                            className={SignupCSS.password_eye}
                            onClick={togglePasswordVisiblity}
                          />
                          <input
                            className={`form-control ${
                              state.errors &&
                              state.errors.password &&
                              "danger-border"
                            }`}
                            type={passwordVisible ? "text" : "password"}
                            name="password"
                            value={state.password}
                            onChange={handleChange}
                            //placeholder="Enter password"
                            // iconRender={(visible) =>
                            //   visible ? <EyeOutlined /> : <EyeInvisibleOutlined />
                            // }
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.password}
                          </span>
                        )}
                        {(state.password === "" ||
                          state.password.length < 8 ||
                          state.password.length < 1) &&
                          state.errors &&
                          !state.errors.password && (
                            <div className="info-icon">
                              <p className="font-12 weight-400 text-yellow margin-top-5 margin-bottom-0">
                                <InfoCircleOutlined className="vertical-middle" />{" "}
                                Password should be atleast 8 characters
                                including a number, an uppercase, one special
                                character and lowercase letter
                              </p>
                            </div>
                          )}
                      </div>
                      <div className="col-md-6">
                        <FloatLabel
                          label="Confirm Password"
                          value={state.confirm_password}
                          name="confirm_password"
                        >
                          <Input.Password
                            className={`form-control ${
                              state.errors &&
                              state.errors.confirm_password &&
                              "danger-border"
                            }`}
                            type="password"
                            name="confirm_password"
                            value={state.confirm_password}
                            onChange={handleChange}
                            //placeholder="Confirm Password"
                            iconRender={(visible) =>
                              visible ? (
                                <img src={imgEyeOpen} alt="Password Eye" />
                              ) : (
                                <img src={imgEyeClosed} alt="Password Eye" />
                              )
                            }
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.confirm_password}
                          </span>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item className="margin-bottom-15">
                    <div className="form-row">
                      <div className="col-md-6">
                        <div className="mobnumber_wrapper">
                          <Select
                            className="custom-arrow"
                            value={state.country_code}
                            name="country_code"
                            onChange={(val) =>
                              handleChange({
                                target: { name: "country_code", value: val },
                              })
                            }
                          >
                            <Option value="+44">+44</Option>
                            <Option value="+91">+91</Option>
                          </Select>
                          <FloatLabel
                            label="Mobile Number"
                            value={state.phone}
                            name="phone"
                          >
                            <input
                              type="text"
                              name="phone"
                              value={state.phone}
                              onChange={handleChange}
                              //placeholder="Enter Mobile Number"
                              className={`form-control ${
                                state.errors &&
                                state.errors.phone &&
                                "danger-border"
                              }`}
                            />
                          </FloatLabel>
                        </div>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.phone}
                          </span>
                        )}
                        {state.phone !== null &&
                          !state.errors.phone &&
                          (state.phone.length < 1 ||
                            state.phone.length > 10) && (
                            <div className="info-icon">
                              <p className="font-12 weight-400 text-yellow margin-top-5 margin-bottom-0">
                                <InfoCircleOutlined className="vertical-middle" />{" "}
                                Mobile no should be of 10 digit
                              </p>
                            </div>
                          )}
                      </div>
                      <div className="col-md-6">
                        <FloatLabel
                          label="Registration Number"
                          value={state.registration_number}
                          name="registration_number"
                        >
                          <Input
                            className={`form-control ${
                              state.errors &&
                              state.errors.registration_number &&
                              "danger-border"
                            }`}
                            name="registration_number"
                            value={state.registration_number}
                            onChange={handleChange}
                            //placeholder="Enter registration number"
                          />
                        </FloatLabel>
                        {state.errors && (
                          <span className="validate-danger">
                            {state.errors.registration_number}
                          </span>
                        )}
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item className="text-center">
                    <button
                      onClick={_handleSubmit}
                      type="submit"
                      disabled={state.loading}
                      className={`${"btn-primary"} btn large-btn margin-top-10`}
                    >
                      {state.loading ? <span>Signing Up...</span> : "Sign Up"}
                    </button>
                  </Form.Item>
                </form>

                <div className="forgot_wrap margin-top-20 text-center">
                  <p className="font-12 weight-500 text-heading margin-0">
                    Already Registered?{" "}
                    <Link
                      to="/signin"
                      className="forget_link styled-link weight-600"
                      title="Sign In"
                    >
                      Sign In
                    </Link>
                  </p>
                </div>
              </div>

              <LoginFooter />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
